import { loadingCatalogFilter } from '../actions/catalogActions';
import { loadingCatalogCiiuFilter } from '../actions/catalogCiiuActions';
import { loadingCatalogSectionFilter } from '../actions/catalogSectionActions';
import { loadingCatalogPhaseFilter } from '../actions/catalogPhaseActions';
import { loadingLocationCountryFilter } from '../actions/countryActions';
import { loadingCatalogInstitutionFilter } from '../actions/catalogInstitutionActions';

/**
 * Facets del getByText*. En path semántico vacío el server puede enviar filterResults=null;
 * no despachar en ese caso (evita crash al destructurar deep_indicator_min, etc.).
 *
 * @param {object} [options]
 * @param {boolean} [options.withSectionPhase=true]
 * @param {boolean} [options.withInstitution=false] — assistance
 */
export const dispatchSearchFilterResults = (dispatch, filterResults, options = {}) => {
  if (filterResults == null || typeof filterResults !== 'object') {
    return false;
  }

  const { withSectionPhase = true, withInstitution = false } = options;

  dispatch(loadingCatalogFilter(filterResults));
  dispatch(loadingCatalogCiiuFilter(filterResults));
  if (withSectionPhase) {
    dispatch(loadingCatalogSectionFilter(filterResults));
    dispatch(loadingCatalogPhaseFilter(filterResults));
  }
  dispatch(loadingLocationCountryFilter(filterResults));
  if (withInstitution) {
    dispatch(loadingCatalogInstitutionFilter(filterResults));
  }
  return true;
};
